var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mx-5 mt-4"},[_c('button',{staticClass:"button is-info",on:{"click":_vm.onClickYesterday}},[_vm._v("Yestarday")])]),_c('DataTable',{attrs:{"is_createable":false,"show_delete":false,"show_operations":false,"show_header_filter":false,"title":"מועמדים מהיום","fields":_vm.fields,"response":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }